import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * De breedte en buitenmarge van elke app-pagina staan hier, en alleen hier.
 *
 * Offertes, Pipeline, Producten en Templates hadden alle vier hun eigen
 * maximumbreedte (1024, 1400 en 1152 px), waardoor de inhoud verschoof zodra je
 * tussen die schermen wisselde. 1400 px is de maat waar de brede schermen om
 * vragen — de pipeline en de producttabellen — en waar de smallere overzichten
 * prima in passen.
 *
 * De publieke offerte, de medeondertekenpagina en de PDF-editor vallen hier
 * bewust buiten: dat zijn documentweergaven met hun eigen papierbreedte.
 */
export const PAGE_CONTAINER_CLASS = 'mx-auto w-full max-w-[1400px] px-6 py-8';

const PageContainer = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn(PAGE_CONTAINER_CLASS, className)} {...props} />
  ),
);
PageContainer.displayName = 'PageContainer';

export { PageContainer };
export default PageContainer;
